'use strict'

import Modal from 'assets/core/js/module/modal'

export default function (): void {
  const modalEl = document.getElementById('cart-recap-modal-reward')
  const alertEl = document.getElementById('cart-recap-alert-reward')

  if (!modalEl || !alertEl) {
    return
  }

  const modal = new Modal(modalEl)

  alertEl.addEventListener('click', () => {
    modal.open()
  })
}
